import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "../../services/api";
import { HiClock, HiDesktopComputer } from "react-icons/hi";

const UserActivity = () => {
    const { data: logs, isLoading } = useQuery({
        queryKey: ["activityLogs"],
        queryFn: async () => {
            const res = await apiRequest('/activity?limit=20');
            return res.data; // Assuming apiRequest returns {success: true, data: []} or similar
        },
    });

    if (isLoading) {
        return (
            <div className="flex justify-center py-8">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-primary"></div>
            </div>
        );
    }

    if (!logs || logs.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-12 text-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800">
                    <HiClock className="h-8 w-8 text-gray-400" />
                </div>
                <h3 className="mt-4 text-lg font-medium text-gray-900 dark:text-white">No activity yet</h3>
                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                    Your recent login and update history will appear here.
                </p>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white">System Activity Logs</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">View your recent actions and login history.</p>
            </div>

            <div className="grid gap-4 sm:grid-cols-2">
                {logs.map((log) => (
                    <div
                        key={log.id}
                        className="rounded-xl border border-gray-200 bg-gray-50 p-4 transition-all hover:bg-white hover:shadow-sm dark:border-gray-700 dark:bg-gray-800/50 dark:hover:bg-gray-800"
                    >
                        <div className="mb-3 flex items-center justify-between">
                            <div className="flex items-center gap-2">
                                <span className={`inline-flex h-2 w-2 rounded-full ${log.action === 'LOGIN' ? 'bg-green-500' : 'bg-blue-500'}`}></span>
                                <span className="font-semibold text-gray-900 dark:text-white uppercase text-xs tracking-wider">{log.action}</span>
                            </div>
                            <span className="rounded-full bg-gray-200 px-2 py-1 text-[10px] font-medium text-gray-600 dark:bg-gray-700 dark:text-gray-300">
                                {log.action === 'LOGIN' ? 'LOGIN' : 'UPDATED'}
                            </span>
                        </div>

                        <div className="mb-2">
                            <p className="text-sm font-medium text-gray-800 dark:text-gray-200">{log.details}</p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">
                                {new Date(log.created_at).toLocaleString()}
                            </p>
                        </div>

                        {log.ip_address && (
                            <div className="mt-3 rounded bg-gray-200/50 p-2 text-xs font-mono text-gray-600 dark:bg-black/20 dark:text-gray-400">
                                <div className="flex items-center gap-1">
                                    <HiDesktopComputer className="h-3 w-3" />
                                    <span>IP: {log.ip_address}</span>
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UserActivity;
